import { render, staticRenderFns } from "./Couponmanage.vue?vue&type=template&id=259ab080&scoped=true&"
import script from "./Couponmanage.vue?vue&type=script&lang=js&"
export * from "./Couponmanage.vue?vue&type=script&lang=js&"
import style0 from "./Couponmanage.vue?vue&type=style&index=0&id=259ab080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259ab080",
  null
  
)

export default component.exports